// 基础验证服务

import tool from '@tool';

function empty(val) {
  return tool.isEmpty(val) === false;
}
empty.tag = 'empty';

function mobile(val) {
  if (tool.isEmpty(val)) {
    return true;
  }

  return tool.regMobile(val);
}
mobile.tag = 'mobile';

function int(val) {
  if (tool.isEmpty(val)) {
    return true;
  }

  return tool.regInt(val);
}
int.tag = 'int';

function email(val) {
  if (tool.isEmpty(val)) {
    return true;
  }

  return tool.regEmail(val);
}
email.tag = 'email';

function wechat(val) {
  if (tool.isEmpty(val)) {
    return true;
  }

  return tool.regWechat(val);
}
wechat.tag = 'wechat';

function max(len) {
  function max(val) {
    if (tool.isEmpty(val)) {
      return true;
    }

    return val.toString().length <= len;
  }
  max.tag = 'max';
  max.errorMsg = `内容不得超过${len}个字`;

  return max;
}

function valids(fns, val) {
  return fns.filter((fn) => {
    return fn(val) === false;
  });
}

function msg(fnName) {
  let msg = '';

  switch (fnName.tag) {
    case 'empty':
      msg = '不可为空';
      break;
    case 'mobile':
      msg = '手机号格式错误';
      break;
    case 'number':
      msg = '必须是数字';
      break;
    case 'email':
      msg = '邮箱格式错误';
      break;
    case 'wechat':
      msg = '微信号只能由数字，字母，下划线或减号组合';
      break;
    case 'max':
      msg = fnName.errorMsg || '内容太长';
      break;
  }

  return msg;
}

export default {
  empty,
  mobile,
  int,
  email,
  wechat,
  max,
  valids,
  msg,
};
